module.exports = __webpack_public_path__ + "img/game_gsport.a1aa478.jpg";